import { render } from "./StatsTab.vue?vue&type=template&id=d47c0a72&scoped=true"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"

import "./StatsTab.vue?vue&type=style&index=0&id=d47c0a72&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47c0a72"]])

export default __exports__